function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M25.46 22.018a1.5 1.5 0 1 1 2.269 1.964l-3.45 3.985a.5.5 0 0 1-.737.02l-2.37-2.452a1.5 1.5 0 0 1 2.157-2.085l.47.487 1.661-1.919zM24.5 33.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0 3c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12-5.373 12-12 12zM26 14a1.5 1.5 0 0 1-3 0V9.5a1.5 1.5 0 0 1 3 0V14zm0 25.5a1.5 1.5 0 0 1-3 0V35a1.5 1.5 0 0 1 3 0v4.5zM35 26a1.5 1.5 0 0 1 0-3h4.5a1.5 1.5 0 0 1 0 3H35zm-21-3a1.5 1.5 0 0 1 0 3H9.5a1.5 1.5 0 0 1 0-3H14z"
});

var SvgTrackingOk = function SvgTrackingOk(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgTrackingOk;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/tracking-ok.svg
// module id = 143
// module chunks = 0 1